// import missingData from "../tools/missingData";

const missingData = (item) => {
  // console.log(item, 'missingData')
  // the item is an Object.entry, so an array of 2 values, the field name and field value
// if there is no value for the field of interest
return (item[1] === undefined || item[1].length < 1 )
}

const calcComplete = (data) => {

  let dataArray = Object.entries(data)

  // incomplete is an array of fields that are undefined or have a length < 1
  let incomplete = dataArray.filter(missingData)
  let complete = dataArray.length - incomplete.length

  let value = complete/ dataArray.length * 100
  
  data.complete = value
  
    return data.complete
}

export default calcComplete